import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon, ArrowRightIcon } from 'lucide-react';
export function DeploymentTiers() {
  return <section id="deploy" className="relative w-full py-24 md:py-32 px-6 md:px-12 bg-[#050508]" data-id="element-68">
      {/* Section header */}
      <div className="max-w-4xl mx-auto text-center mb-16 md:mb-20" data-id="element-69">
        <motion.h2 className="font-['Bebas_Neue'] text-5xl md:text-7xl tracking-wider text-[#C4C4CC] mb-4" initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        amount: 0.3
      }} transition={{
        duration: 0.7
      }} data-id="element-70">
          DEPLOYMENT TIERS
        </motion.h2>
        <motion.div className="w-24 h-[1px] bg-[#FF2D2D] mx-auto mb-6" initial={{
        scaleX: 0
      }} whileInView={{
        scaleX: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8,
        delay: 0.3
      }} data-id="element-71" />
        <motion.p className="text-[#8A8A96] text-base md:text-lg font-light" initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.7,
        delay: 0.4
      }} data-id="element-72">
          Scale from signal to infrastructure
        </motion.p>
      </div>

      {/* Tier cards */}
      <div className="max-w-6xl mx-auto grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8 items-stretch" data-id="element-73">
        {/* NODE */}
        <motion.div className="border border-[#8A8A96]/20 bg-[#0A0A0F] p-8 flex flex-col relative" initial={{
        opacity: 0,
        y: 40
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        amount: 0.3
      }} transition={{
        duration: 0.6,
        delay: 0
      }} data-id="element-74">
          <span className="font-['Bebas_Neue'] text-xs tracking-[0.3em] text-[#8A8A96] mb-2" data-id="element-75">
            TIER 01
          </span>
          <h3 className="font-['Bebas_Neue'] text-4xl tracking-wider text-[#C4C4CC] mb-2" data-id="element-76">
            NODE
          </h3>
          <div className="flex items-baseline gap-1 mb-6" data-id="element-77">
            <span className="font-['Bebas_Neue'] text-4xl text-[#FF2D2D]" data-id="element-78">
              €3,200
            </span>
            <span className="text-[#8A8A96] text-sm" data-id="element-79">/mo</span>
          </div>

          <ul className="space-y-3 mb-8 flex-1" data-id="element-80">
            <li className="flex items-start gap-3" data-id="element-81">
              <CheckIcon className="w-4 h-4 text-[#8A8A96] mt-0.5 flex-shrink-0" data-id="element-82" />
              <span className="text-[#8A8A96] text-sm font-light" data-id="element-83">
                Single-market deployment
              </span>
            </li>
            <li className="flex items-start gap-3" data-id="element-84">
              <CheckIcon className="w-4 h-4 text-[#8A8A96] mt-0.5 flex-shrink-0" data-id="element-85" />
              <span className="text-[#8A8A96] text-sm font-light" data-id="element-86">
                Up to 5,000 active players
              </span>
            </li>
            <li className="flex items-start gap-3" data-id="element-87">
              <CheckIcon className="w-4 h-4 text-[#8A8A96] mt-0.5 flex-shrink-0" data-id="element-88" />
              <span className="text-[#8A8A96] text-sm font-light" data-id="element-89">
                Core matching engine
              </span>
            </li>
            <li className="flex items-start gap-3" data-id="element-90">
              <CheckIcon className="w-4 h-4 text-[#8A8A96] mt-0.5 flex-shrink-0" data-id="element-91" />
              <span className="text-[#8A8A96] text-sm font-light" data-id="element-92">
                Standard analytics dashboard
              </span>
            </li>
            <li className="flex items-start gap-3" data-id="element-93">
              <CheckIcon className="w-4 h-4 text-[#8A8A96] mt-0.5 flex-shrink-0" data-id="element-94" />
              <span className="text-[#8A8A96] text-sm font-light" data-id="element-95">
                Email support
              </span>
            </li>
          </ul>

          <motion.button className="w-full py-3 border border-[#8A8A96]/30 text-[#C4C4CC] font-['Bebas_Neue'] text-lg tracking-wider hover:border-[#C4C4CC]/60 transition-colors flex items-center justify-center gap-2" whileHover={{
          scale: 1.01
        }} whileTap={{
          scale: 0.99
        }} data-id="element-96">
            Deploy Node
            <ArrowRightIcon className="w-4 h-4" data-id="element-97" />
          </motion.button>
        </motion.div>

        {/* CLUSTER - Recommended */}
        <motion.div className="border border-[#FF2D2D]/40 bg-[#0A0A0F] p-8 flex flex-col relative overflow-hidden" initial={{
        opacity: 0,
        y: 40
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        amount: 0.3
      }} transition={{
        duration: 0.6,
        delay: 0.15
      }} data-id="element-98">
          {/* Red top border accent */}
          <div className="absolute top-0 left-0 right-0 h-[2px] bg-[#FF2D2D]" data-id="element-99" />
          {/* Subtle glow */}
          <div className="absolute -top-20 left-1/2 -translate-x-1/2 w-60 h-40 rounded-full pointer-events-none" style={{
          background: 'radial-gradient(ellipse, rgba(255,45,45,0.08) 0%, transparent 70%)'
        }} data-id="element-100" />

          <div className="flex items-center gap-3 mb-2" data-id="element-101">
            <span className="font-['Bebas_Neue'] text-xs tracking-[0.3em] text-[#8A8A96]" data-id="element-102">
              TIER 02
            </span>
            <span className="px-2 py-0.5 bg-[#FF2D2D]/10 border border-[#FF2D2D]/30 text-[#FF2D2D] text-[10px] font-semibold tracking-wider uppercase" data-id="element-103">
              Recommended
            </span>
          </div>
          <h3 className="font-['Bebas_Neue'] text-4xl tracking-wider text-[#C4C4CC] mb-2" data-id="element-104">
            CLUSTER
          </h3>
          <div className="flex items-baseline gap-1 mb-6" data-id="element-105">
            <span className="font-['Bebas_Neue'] text-4xl text-[#FF2D2D]" data-id="element-106">
              €8,100
            </span>
            <span className="text-[#8A8A96] text-sm" data-id="element-107">/mo</span>
          </div>

          <ul className="space-y-3 mb-8 flex-1" data-id="element-108">
            <li className="flex items-start gap-3" data-id="element-109">
              <CheckIcon className="w-4 h-4 text-[#FF2D2D] mt-0.5 flex-shrink-0" data-id="element-110" />
              <span className="text-[#C4C4CC] text-sm font-light" data-id="element-111">
                Multi-market expansion
              </span>
            </li>
            <li className="flex items-start gap-3" data-id="element-112">
              <CheckIcon className="w-4 h-4 text-[#FF2D2D] mt-0.5 flex-shrink-0" data-id="element-113" />
              <span className="text-[#C4C4CC] text-sm font-light" data-id="element-114">
                Up to 50,000 active players
              </span>
            </li>
            <li className="flex items-start gap-3" data-id="element-115">
              <CheckIcon className="w-4 h-4 text-[#FF2D2D] mt-0.5 flex-shrink-0" data-id="element-116" />
              <span className="text-[#C4C4CC] text-sm font-light" data-id="element-117">
                Advanced phantom matching
              </span>
            </li>
            <li className="flex items-start gap-3" data-id="element-118">
              <CheckIcon className="w-4 h-4 text-[#FF2D2D] mt-0.5 flex-shrink-0" data-id="element-119" />
              <span className="text-[#C4C4CC] text-sm font-light" data-id="element-120">
                Real-time relay distribution
              </span>
            </li>
            <li className="flex items-start gap-3" data-id="element-121">
              <CheckIcon className="w-4 h-4 text-[#FF2D2D] mt-0.5 flex-shrink-0" data-id="element-122" />
              <span className="text-[#C4C4CC] text-sm font-light" data-id="element-123">
                Priority integration support
              </span>
            </li>
            <li className="flex items-start gap-3" data-id="element-124">
              <CheckIcon className="w-4 h-4 text-[#FF2D2D] mt-0.5 flex-shrink-0" data-id="element-125" />
              <span className="text-[#C4C4CC] text-sm font-light" data-id="element-126">
                Custom reporting
              </span>
            </li>
          </ul>

          <motion.button className="w-full py-3 bg-[#FF2D2D] text-white font-['Bebas_Neue'] text-lg tracking-wider hover:bg-[#CC1A1A] transition-colors flex items-center justify-center gap-2" whileHover={{
          scale: 1.01
        }} whileTap={{
          scale: 0.99
        }} data-id="element-127">
            Deploy Cluster
            <ArrowRightIcon className="w-4 h-4" data-id="element-128" />
          </motion.button>
        </motion.div>

        {/* GRID - Bespoke */}
        <motion.div className="border border-[#8A8A96]/20 bg-[#0A0A0F] p-8 flex flex-col relative" initial={{
        opacity: 0,
        y: 40
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        amount: 0.3
      }} transition={{
        duration: 0.6,
        delay: 0.3
      }} data-id="element-129">
          <span className="font-['Bebas_Neue'] text-xs tracking-[0.3em] text-[#8A8A96] mb-2" data-id="element-130">
            TIER 03
          </span>
          <h3 className="font-['Bebas_Neue'] text-4xl tracking-wider text-[#C4C4CC] mb-2" data-id="element-131">
            GRID
          </h3>
          <div className="flex items-baseline gap-1 mb-6" data-id="element-132">
            <span className="font-['Bebas_Neue'] text-4xl text-[#FF2D2D]" data-id="element-133">
              Bespoke
            </span>
          </div>

          <ul className="space-y-3 mb-8 flex-1" data-id="element-134">
            <li className="flex items-start gap-3" data-id="element-135">
              <CheckIcon className="w-4 h-4 text-[#8A8A96] mt-0.5 flex-shrink-0" data-id="element-136" />
              <span className="text-[#8A8A96] text-sm font-light" data-id="element-137">
                Continental-scale infrastructure
              </span>
            </li>
            <li className="flex items-start gap-3" data-id="element-138">
              <CheckIcon className="w-4 h-4 text-[#8A8A96] mt-0.5 flex-shrink-0" data-id="element-139" />
              <span className="text-[#8A8A96] text-sm font-light" data-id="element-140">
                Unlimited players
              </span>
            </li>
            <li className="flex items-start gap-3" data-id="element-141">
              <CheckIcon className="w-4 h-4 text-[#8A8A96] mt-0.5 flex-shrink-0" data-id="element-142" />
              <span className="text-[#8A8A96] text-sm font-light" data-id="element-143">
                Full module suite
              </span>
            </li>
            <li className="flex items-start gap-3" data-id="element-144">
              <CheckIcon className="w-4 h-4 text-[#8A8A96] mt-0.5 flex-shrink-0" data-id="element-145" />
              <span className="text-[#8A8A96] text-sm font-light" data-id="element-146">
                Dedicated success team
              </span>
            </li>
            <li className="flex items-start gap-3" data-id="element-147">
              <CheckIcon className="w-4 h-4 text-[#8A8A96] mt-0.5 flex-shrink-0" data-id="element-148" />
              <span className="text-[#8A8A96] text-sm font-light" data-id="element-149">
                Custom SLA
              </span>
            </li>
            <li className="flex items-start gap-3" data-id="element-150">
              <CheckIcon className="w-4 h-4 text-[#8A8A96] mt-0.5 flex-shrink-0" data-id="element-151" />
              <span className="text-[#8A8A96] text-sm font-light" data-id="element-152">
                White-label options
              </span>
            </li>
          </ul>

          <motion.button className="w-full py-3 border border-[#8A8A96]/30 text-[#C4C4CC] font-['Bebas_Neue'] text-lg tracking-wider hover:border-[#C4C4CC]/60 transition-colors flex items-center justify-center gap-2" whileHover={{
          scale: 1.01
        }} whileTap={{
          scale: 0.99
        }} data-id="element-153">
            Contact Grid
            <ArrowRightIcon className="w-4 h-4" data-id="element-154" />
          </motion.button>
        </motion.div>
      </div>
    </section>;
}